export const DEL_ALLDS_RSLTPL = 'DEL_ALLDS_RSLTPL';
export const CHANGE_DS_RSLTPL = 'CHANGE_DS_RSLTPL';
export const CHANGE_CAT_RSLTPL = 'CHANGE_CAT_RSLTPL';
export const RESET_CELL_RSLTPL = 'RESET_CELL_RSLTPL';
export const CLICK_CELL_RSLTPL = 'CLICK_CELL_RSLTPL';
export const CHANGE_SELROW_RSLTPL = 'CHANGE_SELROW_RSLTPL';
export const CHANGE_EXVARCAT_RSLTPL = 'CHANGE_EXVARCAT_RSLTPL';
export const CHANGE_EXVARNAME_RSLTPL = 'CHANGE_EXVARNAME_RSLTPL';
export const CHANGE_EXVARNAMEOPT_RSLTPL = 'CHANGE_EXVARNAMEOPT_RSLTPL';
export const CHANGE_DISTS_RSLTPL = 'CHANGE_DISTS_RSLTPL';

export function delAllDsAction() {
    return {
        type: DEL_ALLDS_RSLTPL
    };
}

export function changeDsAction(ds) {
    return {
        type: CHANGE_DS_RSLTPL,
        ds: ds
    };
}

export function changeCatAction(value) {
    return {
        type: CHANGE_CAT_RSLTPL,
        value: value
    };
}

export function resetCellAction() {
    return {
        type: RESET_CELL_RSLTPL
    };
}

export function clickCellAction(dsID, elemID, geoID, prob) {
    return {
        type: CLICK_CELL_RSLTPL,
        dsID: dsID,
        elemID: elemID,
        geoID: geoID,
        prob: prob
    };
}

export function changeSelRowAction(rowID) {
    return {
        type: CHANGE_SELROW_RSLTPL,
        rowID: rowID
    };
}

export function changeExVarCatAction(value) {
    return {
        type: CHANGE_EXVARCAT_RSLTPL,
        value: value
    };
}

export function changeExVarNameAction(value) {
    return {
        type: CHANGE_EXVARNAME_RSLTPL,
        value: value
    };
}

export function changeExVarNameOptAction(opt) {
    return {
        type: CHANGE_EXVARNAMEOPT_RSLTPL,
        opt: opt
    };
}

export function changeDistsAction(dists) {
    return {
        type: CHANGE_DISTS_RSLTPL,
        dists: dists
    };
}